module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oW1Sce/tc-custom/9781612547725.jpg?1705261440517",
      "alt": "This image is the cover for the book Secret of Peillon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Secret of Peillon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Nazi treasure draws a pair of cunning twins and the descendants of a rogue German general to a small French town in this adventure caper with a dark twist.")]), _c('br'), _c('br'), _vm._v("Peillon is a small town in southern France bordering the Mediterranean, the secret of its treasure hidden away deep inside its caves by the sea. It is up to the grandchildren of the general and each of the twins to uncover this secret. Though they grow up on different continents without any knowledge of each other, their destinies are undeniably intertwined, and fate brings them together to search for the lost Nazi gold. The further they delve into the past however, the more skeletons they dig up. Will the untold wealth of gold they find outweigh the burdens of the past? Will they be content with the truth once they find out they’re all connected by something that’s more than just fate?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Conly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael Conly is retired, formerly the president and CEO of a publically-traded broadcasting company, and now enjoying frequent travels with his wife and son. Mr. Conly spent the earliest part of his media career as a news and programming consultant to networks around the world, specializing in the development of programming concepts and newscasts. Currently he is developing future novels and using his travels to conjure up new ideas. The Conlys divide their time between residing in Texas, Florida, and Colorado.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The Small Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0